<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Issues">Issues</span>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="issues"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="startup-content">

        <!-- Account exists but has no role behind it.
             Shown instead of the (permanently empty) loading grid, because
             nothing is going to load. Signing in again usually completes the
             setup, so that is offered first; contacting us is the fallback,
             and the text asks the user to say they have already created an
             account so support does not start by telling them to register. -->
        <div class="startup-account-incomplete" *ngIf="startupService.accountSetupIncomplete" role="alert">
          <mat-icon class="startup-account-incomplete-icon">report_problem</mat-icon>
          <div class="startup-account-incomplete-text">
            <h2 i18n="@@Your account is not ready yet">Your account is not ready yet</h2>
            <p i18n="@@accountSetupIncompleteBody">Your account was created and you are signed in, but the setup behind it did not finish, so there is nothing to show yet. Signing out and signing in again will often complete it.</p>
            <p i18n="@@accountSetupIncompleteContact">If signing in again does not help, please contact us and let us know that you have already created an account. A system administrator needs to fix it - you do not need to register again.</p>

            <!-- Repair affordance. Calls POST /user/repairaccount and then
                 forces a token refresh - the repair writes custom:roleId to
                 Cognito and the token in hand predates it, so without the
                 refresh a successful repair still renders as broken. -->
            <div class="startup-account-repair">
              <button mat-raised-button color="primary" *ngIf="repairState !== 'REPAIRING'"
                      (click)="repairAccount()"
                      i18n="@@Finish setting up my account">Finish setting up my account</button>

              <span class="startup-account-repair-busy" *ngIf="repairState === 'REPAIRING'">
                <mat-spinner diameter="18"></mat-spinner>
                <span i18n="@@Finishing account setup">Finishing account setup</span>
              </span>

              <div class="startup-account-repair-error" *ngIf="repairState === 'FAILED'" role="alert">
                <p i18n="@@accountRepairFailed">We could not finish setting up your account automatically. Please contact us and let us know that you have already created an account.</p>
                <p class="startup-account-repair-detail" *ngIf="repairErrorMessage">{{repairErrorMessage}}</p>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!startupService.accountSetupIncomplete">
        <!-- Progress Header -->
        <div class="startup-header">
          <div class="startup-header-text">
            <mat-icon class="startup-header-icon">sync</mat-icon>
            <h2 i18n="@@Loading Data">Loading Data</h2>
          </div>
          <div class="startup-progress-summary">
            <span class="startup-stat startup-stat-loaded">
              <mat-icon>check_circle</mat-icon>
              {{getLoadedCount() | numberFormat}}
            </span>
            <span class="startup-stat startup-stat-loading" *ngIf="getLoadingCount() > 0">
              <mat-icon>hourglass_top</mat-icon>
              {{getLoadingCount() | numberFormat}}
            </span>
            <span class="startup-stat startup-stat-error" *ngIf="getErrorCount() > 0">
              <mat-icon>error</mat-icon>
              {{getErrorCount() | numberFormat}}
            </span>
          </div>
        </div>

        <!-- Overall Progress Bar -->
        <div class="startup-overall-progress">
          <div class="startup-overall-bar">
            <div class="startup-overall-fill" [style.width.%]="getOverallProgress()"></div>
          </div>
        </div>

        <!-- Service Cards Grid -->
        <div class="startup-grid">
          <ng-container *ngFor="let service of notificationsService.services | keyvalue">
            <div *ngIf="service.value.loadingState !== 'INITIAL'" class="startup-card"
                 [class.startup-card-loading]="service.value.loadingState === 'LOADING'"
                 [class.startup-card-loaded]="service.value.loadingState === 'LOADED'"
                 [class.startup-card-error]="service.value.loadingState === 'ERROR'">
              <div class="startup-card-header">
                <mat-icon class="startup-card-icon"
                          [class.startup-icon-loading]="service.value.loadingState === 'LOADING'"
                          [class.startup-icon-loaded]="service.value.loadingState === 'LOADED'"
                          [class.startup-icon-error]="service.value.loadingState === 'ERROR'">
                  {{service.value.loadingState === 'LOADED' ? 'check_circle' : (service.value.loadingState === 'ERROR' ? 'error' : 'hourglass_top')}}
                </mat-icon>
                <h3 class="startup-card-title">{{service.key.substring(0, service.key.length - 7) | languageString}}</h3>
              </div>
              <div class="startup-card-body" *ngIf="service.value.objects">
                <div class="startup-card-stat">
                  <span class="startup-card-count">{{service.value.objects.length | numberFormat}}</span>
                  <span class="startup-card-label" i18n="@@Objects">Objects</span>
                </div>
                <span class="startup-card-attach" *ngIf="service.value.objectAttachRequests && getKeys(service.value.objectAttachRequests).length > 0">
                  +{{getKeys(service.value.objectAttachRequests).length | numberFormat}}
                </span>
              </div>
              <div class="startup-card-footer" *ngIf="service.value.loadingState === 'ERROR' && service.value.implementsReload()">
                <button mat-stroked-button color="warn" (click)="reload(service.value)">
                  <mat-icon>refresh</mat-icon> <span i18n="@@Retry">Retry</span>
                </button>
              </div>
              <div class="startup-card-loading-bar" *ngIf="service.value.loadingState === 'LOADING'">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Expandable Attachment Details (debug) -->
        <div *ngIf="expandAttachmentRequests" class="startup-debug">
          <ng-container *ngFor="let service of notificationsService.services | keyvalue">
            <ng-container *ngFor="let objectAttachmentRequests of service.value.objectAttachRequests | keyvalue">
              <div class="startup-debug-item">
                <strong>{{objectAttachmentRequests.key}}</strong>
                <div *ngFor="let req of objectAttachmentRequests.value" class="startup-debug-detail">
                  {{req.objectIdToAttachTo}} · {{req.arrayPropertyToAddTo}} · {{req.objectPropertyToSet}} · {{req.objectToAttach.getId()}}
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        </ng-container>

      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

